import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Admin from "./components/admin/Admin";
import PostPage from "./components/post/PostPage";
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { AuthProvider } from "./config/AuthContext";
import PrivateRoute from "./config/PrivateRoute";
import { ROUTES } from "./config/routes";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path={ROUTES.HOME} component={Home} />
            <Route exact path={ROUTES.POST} component={PostPage} />
            <Route
              exact
              path={ROUTES.PRIVACY_POLICY}
              component={PrivacyPolicy}
            />
            <PrivateRoute exact path={ROUTES.ADMIN} component={Admin} />
          </Switch>
        </Layout>
      </AuthProvider>
    </Router>
  );
};

export default App;
